<template>
  <div class="container">
    <a-row class="main" :gutter="48">
      <a-col :span="12" class="right">
        <div class="l">
          <div class="ph">
            <h1 class="title">枫声商标系统</h1>
<!--            <div class="line"></div>-->
<!--            <h1 class="action">登录</h1>-->
          </div>

          <a-form-model ref="form" :model="form" @submit="on_submit" :rules="rule_validate">


            <a-form-model-item prop="mobile">
              <a-input v-model="form.mobile" size="large" placeholder="手机号码">
                <a-icon slot="prefix" type="mobile" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input type="password" v-model="form.password" size="large" placeholder="密码">
                <a-icon slot="prefix" type="lock" />
              </a-input>
            </a-form-model-item>

            <a-form-model-item prop="captcha">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <a-input style="width: 200px;" v-model="form.captcha" size="large" placeholder="验证码">
                  <a-icon slot="prefix" type="safety-certificate" />
                </a-input>
                <img :src="captchaImg" @click="getCaptchaImg" style="width: 100px;height: 40px;" alt="" />
              </div>
            </a-form-model-item>

            <!-- <a-form-model-item>
                 <div class="nc-container" id="nc-container" :disabled="!form.mobile || !form.password || !form.captcha"></div>
             </a-form-model-item>-->

            <a-form-model-item>
              <a-button
                block
                size="large"
                type="primary"
                html-type="submit"
                :loading="submitting"
                :disabled="!form.mobile || !form.password || !form.captcha"
              >登录
              </a-button
              >
            </a-form-model-item>


          </a-form-model>
        </div>

        <footer>Copyright © 2023 All Rights Reserved </footer>
<!--        <footer>Copyright © 2023 All Rights Reserved 沪ICP备19016591号-2</footer>-->
      </a-col>

      <a-col :span="12" class="left">
        <div class="bg">
          <!-- <img class="logo" src="../../images/logo-07-fff.png" /> -->
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import * as Cookies from "js-cookie";

export default {
  data() {
    return {
      submitting: false,
      captchaImg: "",
      form: {
        mobile: "",
        password: "",
        captcha: "",
        captcha_token: ""
      },
      rule_validate: {
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["change", "blur"]
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["change", "blur"]
          }
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["change", "blur"]
          }
        ]
      }
    };
  },
  mounted() {
    this.getCaptchaImg();

    //验证码
    // var nc_token = ["FFFF0N0N000000008717", new Date().getTime(), Math.random()].join(":");
    // var NC_Opt = {
    //   renderTo: "#nc-container",
    //   appkey: "FFFF0N0N000000008717",
    //   scene: "nc_login",
    //   token: nc_token,
    //   customWidth: 320,
    //   trans: { key1: "code0" },
    //   elementID: ["usernameID"],
    //   is_Opt: 0,
    //   language: "cn",
    //   isEnabled: true,
    //   timeout: 3000,
    //   times: 5,
    //   callback: (data) => {
    //     this.form.captcha = data;
    //     // vm.captchaSuccess = true
    //     this.on_submit();
    //   }
    // };
    // var nc = new noCaptcha(NC_Opt);
    // nc.upLang("cn", {
    //   _startTEXT: "拖动滑块以登录",
    //   _yesTEXT: "验证通过",
    //   _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
    //   _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>"
    // });
  },
  methods: {
    on_submit(e) {
      e.preventDefault();
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$http
            .post("/auth/authenticate", this.form)
            .then((res) => {
              if (res.success) {
                Cookies.set("remember_account", this.form.mobile);

                const query = this.$route.query;
                let url_callback = query["redirect_url"] || "/";

                window.top.location.href = decodeURI(url_callback);

                this.submitting = true;
              } else {
                this.submitting = false;
                if (res.message_type === "modal") {
                  this.$error({
                    title: "登录失败",
                    content: res.message
                  });
                } else {
                  this.$message.error(res.message);
                }
              }
            })
            .catch(() => {
              this.getCaptchaImg();
              this.submitting = false;
              this.$error({
                title: "失败",
                centered: true,
                content: "登录失败，请检查当前网络是否畅通"
              });
            })
            .then(() => {
              this.getCaptchaImg();
              this.form.captcha = null;
            });
        } else {
          // __nc.reset();
        }
      });
    },
    getCaptchaImg() {
      this.$http.post("auth/captcha/generate").then(res => {
        this.form.captcha_token = res.data.captcha_token;
        this.captchaImg = res.data.src;
      });
    },
    on_reset() {
      this.$refs["form"].resetFields();
    }
  }
};
</script>

<style lang="less" scoped>

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  // background-color: #F9FAFC;
  //background: url(https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets/image/beijing.webp);
  background: url(https://zonx.oss-cn-hangzhou.aliyuncs.com/static/images/bg/52112_sFDVTTEX.svg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;

  .main {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    padding: 0;
    border-radius: 5px;

    .left {
      position: relative;
      height: 100%;
      margin: 0;
      padding: 0 !important;

      .bg {
        background-color: transparent;
        // background-image: url("../../images/1054397.jpeg");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;

        .logo {
          width: 80px;
          height: 80px;
          position: absolute;
          left: 50px;
          top: 50px;
        }
      }
    }

    .right {
      position: relative;
      height: 100%;

      &::before {
        filter: blur(1px);
        position: absolute;
        background: #ffffff42;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }

      .l {
        max-width: 380px;
        min-width: 320px;
        min-height: 410px;
        position: absolute;
        top: 50%;
        margin-left: auto;
        margin-right: auto;
        margin-top: -205px;
        left: 50%;
        margin-left: -160px;

        .ph {
          .logo {
            width: 40px;
            height: 40px;
            margin-right: 12px;
            border-radius: 50%;
          }

          margin-bottom: 48px;
          display: flex;
          align-items: center;

          .title {
            margin-bottom: 0;
          }

          .line {
            width: 1px;
            background: #424242;
            height: 32px;
            display: block;
            position: relative;
            margin: 0 12px;
          }

          .action {
            color: #ff5722;
            font-weight: 300;
            margin-bottom: 0;
          }
        }
      }
    }
  }

  footer {
    position: absolute;
    bottom: 10px;
    width: 100%;
    font-size: 12px;
    text-align: center;
  }
}
</style>
